




























/* General */
import Vue from 'vue'
import * as routerNames from '@/services/router/router.names'
import MainContainer from '@/layouts/main-container.vue'
import DefaultLayout from '@/layouts/default-layout.vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { INavMenuGroup } from '@/types/data-objects/global'

/* API */

export default Vue.extend({
  name: 'MailboxSettingsLayout',

  components: {
    MainContainer,
    DefaultLayout,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      ColorAssistant,
      routerNames,
    }
  },

  computed: {
    sidebarElements(): INavMenuGroup[] {
      const items = [
        {
          label: 'Setup',
          options: [
            {
              value: routerNames.MAILBOX_SETTINGS_AUTO_FORWARDING,
              label: 'Auto-Forwarding',
              icon: 'auto-forwarding',
              isActive:
                this.$route.name ===
                routerNames.MAILBOX_SETTINGS_AUTO_FORWARDING,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_OUTGOING_EMAIL,
              label: 'Outgoing Email',
              icon: 'outgoing-email',
              isActive:
                this.$route.name ===
                routerNames.MAILBOX_SETTINGS_OUTGOING_EMAIL,
            },
          ],
        },
        {
          label: 'Manage',
          options: [
            {
              value: routerNames.MAILBOX_SETTINGS_ASSIGN_PEOPLE,
              label: 'Add/Remove Users',
              icon: 'people',
              isActive:
                this.$route.name === routerNames.MAILBOX_SETTINGS_ASSIGN_PEOPLE,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_CONVERSATION_RULES,
              label: 'Conversation Rules',
              icon: 'incoming-email',
              isActive:
                this.$route.name ===
                routerNames.MAILBOX_SETTINGS_CONVERSATION_RULES,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_CHECKLIST_TEMPLATES,
              label: 'Checklist Templates',
              icon: 'everything',
              isActive:
                this.$route.name ===
                routerNames.MAILBOX_SETTINGS_CHECKLIST_TEMPLATES,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_SAVED_REPLIES,
              label: 'Saved Replies',
              icon: 'saved-replies',
              isActive:
                this.$route.name === routerNames.MAILBOX_SETTINGS_SAVED_REPLIES,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_OFFICE_HOURS,
              label: 'Office Hours',
              icon: 'clock',
              isActive:
                this.$route.name === routerNames.MAILBOX_SETTINGS_OFFICE_HOURS,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_AUTO_RESPONDER,
              label: 'Auto-Responder',
              icon: 'auto-responder',
              isActive:
                this.$route.name ===
                routerNames.MAILBOX_SETTINGS_AUTO_RESPONDER,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_EMAIL_SIGNATURE,
              label: 'Email Signature',
              icon: 'edit',
              isActive:
                this.$route.name ===
                routerNames.MAILBOX_SETTINGS_EMAIL_SIGNATURE,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_MANAGE_WORKFLOW,
              label: 'Manage Workflow',
              icon: 'workflows',
              isActive:
                this.$route.name ===
                routerNames.MAILBOX_SETTINGS_MANAGE_WORKFLOW,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_GENERAL_SETTINGS,
              label: 'General Settings',
              icon: 'cog',
              isActive:
                this.$route.name ===
                routerNames.MAILBOX_SETTINGS_GENERAL_SETTINGS,
            },
            {
              value: routerNames.MAILBOX_SETTINGS_INTEGRATIONS,
              label: 'Integrations',
              icon: 'integrations',
              isActive:
                this.$route.name === routerNames.MAILBOX_SETTINGS_INTEGRATIONS,
            },
          ],
        },
      ]

      /* Eventually, always add this option to menu and let AO click because the ticket portal page 
         itself will have the <feature-gated-stamp /> applied to it. */
      if (this.$permissions.ticketPortalFeatureEnabled) {
        items.find(i => i.label === 'Setup').options.push({
          value: routerNames.MAILBOX_SETTINGS_TICKET_PORTAL,
          label: 'Ticket Portal',
          icon: 'ticket-portal',
          isActive:
            this.$route.name === routerNames.MAILBOX_SETTINGS_TICKET_PORTAL,
        })
      }

      return items
    },
  },

  methods: {
    goToMailbox() {
      RouteAssistant.goToMailbox(
        this.$router,
        this.$route.params.accountId,
        this.$route.params.id,
      )
    },
  },
})
